import React, { useEffect, useState } from "react";
import { Badge, Button } from "react-bootstrap";
import RetentionRunMiniRow from "./RetentionRunMiniRow";
import { FaMagic } from "react-icons/fa";
import api from "../api";
import { useNavigate } from "react-router-dom";
import { ArrowUpRight, X } from "react-feather";
import { PaystackButton } from "react-paystack";

const ReorderAgentCard = ({ state = "NO_ORDERS", data = {} }) => {
  const baseUrl = process.env.REACT_APP_BASE_URL;
    
  const navigate = useNavigate();

  const [creatingRun, setCreatingRun] = useState(false);
  
  const [showSmsStatus, setShowSmsStatus] = useState(false);

  const [analysis, setAnalysis] = useState(null);
  const [runs, setRuns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showRecharge, setShowRecharge] = useState(false);
  const [toastMessage, setToastMessage] = useState(null);
  const [rechargeAmount, setRechargeAmount] = useState(50);
  const launchPolicy = analysis?.launch_policy;
  const canLaunch = launchPolicy?.can_launch;
  

  const stateContent = {
    NO_ORDERS: {
      badge: "• Setup",
      badgeClass: "bg-warning text-dark",
      title: "Your repeat customers are still invisible",
      body: "Upload your order history and the Reorder Agent will identify customers most likely to buy again.",
      cta: "Add Orders",
    },

    HAS_ORDERS: {
      badge: "• Ready",
      badgeClass: "bg-warning text-dark",
      title: "Customers are ready to come back",
      body:
        "Kadhr found buyers likely to reorder. In one click, you can reach out, bring them back, and turn this into real revenue.",
      cta: "Recover Customers",
    },

    ACTIVE: {
      badge: "• Active",
      badgeClass: "bg-success-subtle text-success",
      title: "Your recovery engine is running",
      body: "Latest Campaigns.",
      cta: "View Dashboard",
    },
  };

  const content = stateContent[state];

      // UPDATE useEffect TO THIS
    useEffect(() => {

      // no orders → stop
      if (state === "NO_ORDERS") {
        setLoading(false);
        return;
      }

      const headers = {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      };

      // HAS ORDERS → run analysis
      if (state === "HAS_ORDERS") {
        api
          .get(baseUrl + "/retention/analysis/", { headers })
          .then((res) => {
            setAnalysis(res.data);
            setLoading(false);
          })
          .catch(() => setLoading(false));
      }

      // ACTIVE → fetch runs/history
      if (state === "ACTIVE") {

        // FETCH RUNS
        api
          .get(baseUrl + "/retention/runs/", {
            headers,
          })
          .then((res) => {

            setRuns(res.data?.runs || []);

            // KEEP LOADING FALSE
            setLoading(false);
          })
          .catch(() => {
            setLoading(false);
          });

        // ALSO FETCH ANALYSIS
        api
          .get(baseUrl + "/retention/analysis/", {
            headers,
          })
          .then((res) => {
            setAnalysis(res.data);
          })
          .catch(() => {});
      }
      

    }, [state, baseUrl]);

    // ADD useEffect
    useEffect(() => {
      const storedToast =
        localStorage.getItem("kadhr_toast");

      if (storedToast) {
        const parsed = JSON.parse(storedToast);

        setToastMessage(parsed);

        localStorage.removeItem("kadhr_toast");

        setTimeout(() => {
          setToastMessage(null);
        }, 5000);
      }
    }, []);

    const handleLaunchCampaign = async () => {
      try {
        setCreatingRun(true);

        const res = await api.post(
          `${baseUrl}/retention/runs/create/`,
          {},
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );

        if (res.data.success) {
          navigate(res.data.redirect_url);
        }
      } catch (err) {
        console.log(err);
      } finally {
        setCreatingRun(false);
      }
    };

    const vendorDataRaw = localStorage.getItem("VendorData");

    let vendorEmail = "demo@kadhr.com";

    try {
      if (vendorDataRaw) {
        const vendorData = JSON.parse(vendorDataRaw);

        if (vendorData?.email) {
          vendorEmail = vendorData.email;
        }
      }
    } catch (err) {}

    const publicKey = process.env.REACT_APP_PAYSTACK_PUBLIC_KEY;

    const makeTransRef = () =>
      "TRANS-" + Math.floor(Math.random() * 99999999);

    const paystackProps = {
      email: vendorEmail,
      amount: rechargeAmount * 100,
      currency: "KES",
      metadata: { purpose: "SMS Recharge" },
      publicKey,
      text: "Confirm Recharge",

      // UPDATE onSuccess 
      onSuccess: async (reference) => {
        try {
          const trxref =
            reference?.reference || "N/A";

          await api.post(
            baseUrl + "/sms-checkout/",
            {
              total_amount: rechargeAmount,
              email: vendorEmail,
              trxref: trxref,
              trans: makeTransRef(),
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem(
                  "access_token"
                )}`,
              },
            }
          );

          // UPDATE LOCAL SMS
          setAnalysis((prev) => ({
            ...prev,
            sms: (prev?.sms || 0) + rechargeAmount,
          }));

          // CLOSE MODAL
          setShowRecharge(false);

          // SAVE TOASTER MESSAGE
          localStorage.setItem(
            "kadhr_toast",
            JSON.stringify({
              type: "success",
              message:
                "SMS recharge successful. Proceed to launch campaign.",
            })
          );

          // REDIRECT
          navigate("/seller/dashboard");

        } catch (error) {
          console.log(error);
        }
      },

      onClose: () => setShowRecharge(false),
    };

  return (    
    <div
      className="p-3 pb-0"
      style={{
        borderRadius: "20px",     
      }}
    >
      {toastMessage && (
        <div
          style={{
            position: "fixed",
            top: "20px",
            right: "20px",
            zIndex: 9999,
            minWidth: "320px",
            borderRadius: "14px",
            padding: "14px 16px",
            background: "#111",
            color: "#fff",
            boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
            animation: "fadeIn 0.3s ease",
          }}
        >
          <div
            className="fw-bold mb-1"
            style={{ fontSize: "14px" }}
          >
            ✅ Success
          </div>

          <div
            style={{
              fontSize: "0.8em",
              opacity: 0.9,
            }}
          >
            {toastMessage.message}
          </div>
        </div>
      )}
      {/* Header */}
      <div className="position-relative">
        <Badge
          className={`${content.badgeClass} position-absolute top-0 end-0 mt-1 font7`}
        >
          {content.badge}
        </Badge>

        <h4 className="fw-bold-1 mb-0">Reorder Agent</h4>

        <p className="text-dark opacity-75 mb-3 font7 font-bold">
          <FaMagic /> {content.title}
        </p>
      </div>

      {/* Inner Card */}
      <div
        className="bg-white p-3"
        style={{
          borderRadius: "18px",
          boxShadow:"0px 1px 2px 1px rgba(99, 127, 210, 0.22)",
        }}
      >
        {/* LOADING */}
        {loading ? (
          <>
            <style>
              {`
                @keyframes kadhrShimmer {
                  0% {
                    background-position: -500px 0;
                  }
                  100% {
                    background-position: 500px 0;
                  }
                }

                .kadhr-skeleton {
                  background: linear-gradient(
                    90deg,
                    #f3f4f6 25%,
                    #ffffff 50%,
                    #f3f4f6 75%
                  );
                  background-size: 1000px 100%;
                  animation: kadhrShimmer 1.4s infinite linear;
                }
              `}
            </style>

            <div className="mt-1">
              {/* headline */}
              <div
                className="kadhr-skeleton mb-3"
                style={{
                  height: "16px",
                  width: "55%",
                  borderRadius: "10px",
                }}
              />

              {/* main metric */}
              <div
                className="kadhr-skeleton mb-4"
                style={{
                  height: "42px",
                  width: "65%",
                  borderRadius: "12px",
                }}
              />

              {/* progress bar */}
              <div
                className="kadhr-skeleton mb-3"
                style={{
                  height: "14px",
                  width: "100%",
                  borderRadius: "999px",
                }}
              />

              {/* chips */}
              <div className="d-flex gap-2 flex-wrap mb-4">
                {[1, 2, 3, 4].map((item) => (
                  <div
                    key={item}
                    className="kadhr-skeleton"
                    style={{
                      height: "28px",
                      width: "90px",
                      borderRadius: "999px",
                    }}
                  />
                ))}
              </div>

              {/* CTA */}
              <div
                className="kadhr-skeleton"
                style={{
                  height: "42px",
                  width: "100%",
                  borderRadius: "12px",
                }}
              />
            </div>
          </>
        ) : (
          <>
            {/* NO ORDERS */}
            {state === "NO_ORDERS" && (
              <div
                className="mb-0 p-1"
                style={{
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                
                <h5 className="fw800 text-grey-blue">Let's get started.</h5>
                {/* Body */}
                <div className="mt-3">
                  
                  <div
                    className="d-flex align-items-start mb-3"
                  >
                    <div
                      style={{
                        width: "2em",
                        height: "2em",
                        borderRadius: "50%",
                        background: "#eef6ff",
                        color: "#2563eb",
                        fontSize: "0.75em",
                        fontWeight: 700,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: "1em",
                        flexShrink: 0,
                      }}
                    >
                      1
                    </div>

                    <div>
                      <div className="text-grey-blue"
                        style={{
                          fontSize: "1em",
                          fontWeight: 600,
                          color: "#111827",
                        }}
                      >
                        Add order history
                      </div>

                      <div 
                        style={{
                          fontSize: "0.75em",
                          color: "#6b7280",
                          marginTop: "2px",
                        }}
                      >
                        Connect your WooCommerce store or upload historical orders.
                      </div>

                      <div className="mt-2 d-flex flex-wrap gap-2">                       

                        <span
                          className="pointer"
                          data-bs-toggle="modal"
                          data-bs-target="#addorder"
                          style={{
                            fontSize: "0.85em",
                            fontWeight: 600,
                            color: "#2563eb",
                          }}
                        >
                          Upload Orders <ArrowUpRight width={18}/>
                        </span>

                        <span
                          style={{
                            fontSize: "0.85em",
                            fontWeight: 600,
                            color: "#3c4644",
                          }}
                        >
                          or
                        </span>

                        <span
                          className="pointer"
                          onClick={() => navigate("/seller/getapikey")}
                          style={{
                            fontSize: "0.85em",
                            fontWeight: 600,
                            color: "#2563eb",
                          }}
                        >
                          Connect Store <ArrowUpRight width={18}/>
                        </span>

                      </div>
                    </div>
                  </div>

                  <div
                    className="d-flex align-items-start"
                  >
                    <div
                      style={{
                        width: "2em",
                        height: "2em",
                        borderRadius: "50%",
                        background: "#ecfdf5",
                        color: "#16a34a",
                        fontSize: "0.75em",
                        fontWeight: 700,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: "1em",
                        flexShrink: 0,
                      }}
                    >
                      2
                    </div>

                    <div>
                      <div className="text-grey-blue"
                        style={{
                          fontSize: "1em",
                          fontWeight: 600,
                          color: "#111827",
                        }}
                      >
                        Let the Reorder Agent analyze your data
                      </div>

                      <div
                        style={{
                          fontSize: "0.75em",
                          color: "#6b7280",
                          marginTop: "2px",
                          lineHeight: "1.6",
                        }}
                      >
                        Discover repeat buyers, predict revenue opportunities,
                        and recover sales automatically.
                      </div>

                    </div>
                  </div>


                      <div
                        className="mt-3 d-flex flex-wrap"
                        style={{
                          gap: "6px",
                        }}
                      >
                        <span
                          style={{
                            background: "rgba(124,58,237,.08)",
                            color: "#6d28d9",
                            borderRadius: "999px",
                            padding: "4px 8px",
                            fontSize: "0.68em",
                            fontWeight: 600,
                          }}
                        >
                          🔄 Repeat Purchases
                        </span>

                        <span
                          style={{
                            background: "rgba(22,163,74,.08)",
                            color: "#15803d",
                            borderRadius: "999px",
                            padding: "4px 8px",
                            fontSize: "0.68em",
                            fontWeight: 600,
                          }}
                        >
                          💰 Revenue Recovery
                        </span>

                        <span
                          style={{
                            background: "rgba(234,88,12,.08)",
                            color: "#c2410c",
                            borderRadius: "999px",
                            padding: "4px 8px",
                            fontSize: "0.68em",
                            fontWeight: 600,
                          }}
                        >
                          📦 Predicted Reorders
                        </span>
                      </div>
                </div>

                

                {/* Footer */}
                <div
                  className="mt-4 pt-3"
                  style={{
                    borderTop: "1px solid #ece5d8",
                  }}
                >
                  <div
                    style={{
                      fontSize: "0.8em",
                      color: "#78716c",
                    }}
                  >
                    No setup required. Upload orders and let the agent do the work.
                  </div>
                </div>

              </div>
            )}

            {/* HAS ORDERS */}
            {state === "HAS_ORDERS" && (
              <>

                {analysis?.summary && (
                  <div className="mt-0">
                    

                    {/* SMART RECOVERY CARD */}
                    <div
                      className="mb-4 p-3"
                      style={{
                        borderRadius: "7px",
                        background: "#f6f1e7",
                        position: "relative",
                        overflow: "hidden",
                      }}
                    >
                      <div
                        style={{
                          position: "absolute",
                          top: "-15px",
                          right: "-15px",
                          width: "60px",
                          height: "60px",
                          borderRadius: "50%",
                          background: "rgba(255,255,255,0.35)",
                        }}
                      />

                      <div
                        className="fw-bold mb-1"
                        style={{
                          fontSize: "15px",
                        }}
                      >
                        ✨ Revenue Opportunity Detected
                      </div>
                      

                      <div
                        className="text-muted"
                        style={{
                          fontSize: "0.8em",
                          lineHeight: "1.4",
                        }}
                      >
                        Kadhr analyzed your customer history and found{" "}
                        <strong>
                          {analysis.summary.opportunity_count}
                        </strong>{" "}
                        repeat revenue opportunities worth{" "}
                        <strong>
                          KES{" "}
                          {analysis.summary.predicted_revenue.toLocaleString()} 
                        </strong>
                        . In one click, you can reach out, bring them back, and turn this into real revenue.
                      </div>
                    </div>

                    {/* TOP SUMMARY */}
                    <div className="d-flex justify-content-between align-items-start mb-2">
                      <div>
                        <small
                          className="text-muted d-block"
                          style={{ fontSize: "12px" }}
                        >
                          Repeat revenue potential
                        </small>

                        <h2
                          className="fw-bold mb-0"
                          style={{
                            fontSize: "32px",
                            letterSpacing: "-1px",
                          }}
                        >
                          KES{" "}
                          {analysis.summary.predicted_revenue.toLocaleString()}
                        </h2>
                      </div>

                      <div
                        className="d-flex align-items-center justify-content-center"
                        style={{
                          width: "42px",
                          height: "42px",
                          borderRadius: "50%",
                          background: "#f5f5f5",
                        }}
                      >
                        <FaMagic size={15} />
                      </div>
                    </div>

                    {/* OPPORTUNITY BAR */}
                    {(() => {
                      const ready =
                        analysis?.opportunity_preview?.ready_to_reorder || 0;

                      const atRisk =
                        analysis?.segments?.at_risk_customers?.length || 0;

                      const highValue =
                        analysis?.segments?.high_value_customers?.length || 0;

                      const newCustomers =
                        analysis?.segments?.new_customers?.length || 0;

                      const total =
                        ready + atRisk + highValue + newCustomers;

                      const getWidth = (value) => {
                        if (!total) return "0%";
                        return `${(value / total) * 100}%`;
                      };

                      return (
                        <>
                          <div
                            className="d-flex overflow-hidden mb-2"
                            style={{
                              height: "14px",
                              borderRadius: "20px",
                              gap: "3px",
                            }}
                          >
                            {/* READY */}
                            <div
                              style={{
                                width: getWidth(ready),
                                background: "#9b5de5",
                                borderRadius: "20px",
                                transition: "0.4s ease",
                              }}
                            />

                            {/* AT RISK */}
                            <div
                              style={{
                                width: getWidth(atRisk),
                                background: "#2196f3",
                                borderRadius: "20px",
                                transition: "0.4s ease",
                              }}
                            />

                            {/* HIGH VALUE */}
                            <div
                              style={{
                                width: getWidth(highValue),
                                background: "#22c55e",
                                borderRadius: "20px",
                                transition: "0.4s ease",
                              }}
                            />

                            {/* NEW */}
                            <div
                              style={{
                                width: getWidth(newCustomers),
                                background: "#fb8500",
                                borderRadius: "20px",
                                transition: "0.4s ease",
                              }}
                            />
                          </div>

                          {/* LEGEND */}
                          <div className="d-flex flex-wrap gap-2 mb-4">
                            <small
                              className="px-2 py-1"
                              style={{
                                background: "#f7f1ff",
                                color: "#9b5de5",
                                borderRadius: "999px",
                                fontSize: "11px",
                                fontWeight: 600,
                              }}
                            >
                              ♻️ Ready ({ready})
                            </small>

                            <small
                              className="px-2 py-1"
                              style={{
                                background: "#eef6ff",
                                color: "#2196f3",
                                borderRadius: "999px",
                                fontSize: "11px",
                                fontWeight: 600,
                              }}
                            >
                              🚨 At risk ({atRisk})
                            </small>

                            <small
                              className="px-2 py-1"
                              style={{
                                background: "#eefbf3",
                                color: "#22c55e",
                                borderRadius: "999px",
                                fontSize: "11px",
                                fontWeight: 600,
                              }}
                            >
                              💎 High value ({highValue})
                            </small>

                            <small
                              className="px-2 py-1"
                              style={{
                                background: "#fff5eb",
                                color: "#fb8500",
                                borderRadius: "999px",
                                fontSize: "11px",
                                fontWeight: 600,
                              }}
                            >
                              🆕 New ({newCustomers})
                            </small>
                          </div>
                        </>
                      );
                    })()}
                  </div>
                )}
              </>
            )}

            {/* ACTIVE */}
            {state === "ACTIVE" && (
              <>
                <div className="d-flex justify-content-between align-items-end mb-3">

                  <div>

                    <div
                      style={{
                        fontSize: "0.95em",
                        fontWeight: 700,
                        color: "#111827",
                      }}
                    >
                      Recovery Timeline
                    </div>

                    <div
                      style={{
                        fontSize: "0.72em",
                        color: "#6b7280",
                        marginTop: "2px",
                      }}
                    >
                      Customer recovery runs overview.
                    </div>

                  </div>

                  {runs?.length > 0 && (
                    <span
                      className="pointer"
                      onClick={() => navigate("/seller/retarget/runs")}
                      style={{
                        fontSize: "0.72em",
                        fontWeight: 600,
                        color: "#2563eb",
                      }}
                    >
                      View all →
                    </span>
                  )}

                </div>
                {runs?.length > 0 ? (
                    <>
                      {runs.slice(0, 7).map((run) => (
                        <RetentionRunMiniRow
                          key={run.id}
                          run={run}
                          active={false}
                          onClick={(selectedRun) => {
                            navigate(
                              `/seller/retarget/run/${selectedRun.id}`
                            );
                          }}
                        />
                      ))}
                    </>
                  ) : (
                    <div className="text-muted font1">
                      No active recovery runs yet.
                    </div>
                  )}

              </>
            )}
          </>
        )}

        {/* Footer */}
        {!loading && state !== "NO_ORDERS" && !((state === "HAS_ORDERS" || state === "ACTIVE") && showSmsStatus) && (
          <div className="text-left mt-45 mb-0">
            <div className="text-dark opacity-75 font9 font-bold mb-1">           

              {state === "HAS_ORDERS" &&
                "Customers are waiting to buy"}

              {state === "ACTIVE" &&
                "•"}
            </div>

            {/* NO ORDERS */}
            {state !== "NO_ORDERS" && (
              <Button
                variant="dark"
                size="sm"
                className="font9 w-100 p-2"
                style={{ borderRadius: "10px" }}
                disabled={!canLaunch}
                onClick={() => {

                  if (!canLaunch) return;

                  setShowSmsStatus(true);
                }}
              >
                {
                  !canLaunch
                    ? `Available in ${launchPolicy?.days_until_next_launch || "...."} days`
                    : state === "ACTIVE"
                    ? "Launch Another Campaign"
                    : "Launch Campaign"
                }
              </Button>
            )}
            
            {!loading && !canLaunch && runs?.length > 0 && (
              <div
                className="mt-3 p-3"
                style={{
                  borderRadius: "12px",
                  background: "#fefaf5",
                  border: "1px solid #f6d7b8",
                  borderLeft: "4px solid #f59e0b",
                }}
              >
                <div className="d-flex justify-content-between align-items-start">
                  <div>
                    <div
                      style={{
                        fontSize: "0.8em",
                        fontWeight: 600,
                        color: "#92400e",
                      }}
                    >
                      🛡 Smart cooldown active
                    </div>

                    <div
                      className="mt-1"
                      style={{
                        fontSize: "12px",
                        color: "#4b5563",
                        lineHeight: "1.5",
                      }}
                    >
                      The Reorder Agent will be ready to launch another
                      recovery run in{" "}
                      <strong>
                        {launchPolicy?.days_until_next_launch} day(s)
                      </strong>
                      .
                    </div>
                  </div>

                  <span
                    className="pointer"
                    data-bs-toggle="modal"
                    data-bs-target="#cooldownInfoModal"
                    style={{
                      fontSize: "11px",
                      fontWeight: 600,
                      color: "#b45309",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Learn more
                  </span>
                </div>

                <div
                  className="mt-2 d-flex flex-wrap align-items-center"
                  style={{
                    gap: "12px",
                  }}
                >
                  <span
                    className="pointer"
                    data-bs-toggle="modal"
                    data-bs-target="#addorder"
                    style={{
                      fontSize: "12px",
                      color: "#b45309",
                      fontWeight: 600,
                    }}
                  >
                    Add new orders
                  </span>

                  <span style={{ color: "#d1d5db" }}>•</span>

                  <span
                    className="pointer"
                    onClick={() => navigate("/seller/retarget/runs")}
                    style={{
                      fontSize: "12px",
                      color: "#b45309",
                      fontWeight: 600,
                    }}
                  >
                    Campaign history
                  </span>
                </div>
              </div>
            )}
          </div>
        )}       

        {/* SMS STATUS */}
        {!loading && showSmsStatus && (
          <div
            className="mt-3 p-3"
            style={{
              borderRadius: "16px",
              background:
                analysis?.sms >= analysis.summary.estimated_sms_cost
                  ? "#eefbf3"
                  : "#fff4f4",
              border:
                analysis?.sms >= analysis.summary.estimated_sms_cost
                  ? "1px solid #d7f5df"
                  : "1px solid #ffd6d6",
              position: "relative",
              overflow: "hidden",
            }}
          >
            {/* CLOSE */}
            <button
              onClick={() => setShowSmsStatus(false)}
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                border: "none",
                background: "transparent",
                padding: 0,
                zIndex: 10,
                color: "#777",
              }}
            >
              <X size={18} />
            </button>

            {/* Decorative bubble */}
            <div
              style={{
                position: "absolute",
                top: "-18px",
                right: "-18px",
                width: "70px",
                height: "70px",
                borderRadius: "50%",
                background:
                  analysis?.sms >= analysis.summary.estimated_sms_cost
                    ? "rgba(34,197,94,0.08)"
                    : "rgba(239,68,68,0.08)",
              }}
            />

            {/* Header */}
            <div className="d-flex justify-content-between align-items-start">
              <div>
                <div
                  className="fw-bold mb-1"
                  style={{
                    fontSize: "15px",
                    color:
                      analysis?.sms >= analysis.summary.estimated_sms_cost
                        ? "#16a34a"
                        : "#dc2626",
                  }}
                >
                  {analysis?.sms >=
                  analysis.summary.estimated_sms_cost
                    ? "✅ SMS campaign ready"
                    : "⚠️ Insufficient SMS balance"}
                </div>

                <div
                  className="text-muted"
                  style={{
                    fontSize: "0.8em",
                    lineHeight: "1.45",
                    maxWidth: "90%",
                  }}
                >
                  {analysis?.sms >=
                  analysis.summary.estimated_sms_cost ? (
                    <>
                      You have enough SMS credits to recover{" "}
                      <strong>
                        {analysis.summary.opportunity_count}
                      </strong>{" "}
                      customers instantly.
                    </>
                  ) : (
                    <>
                      You need{" "}
                      <strong>
                        {analysis.summary.estimated_sms_cost -
                          analysis.sms}
                      </strong>{" "}
                      more SMS credits to launch this recovery
                      campaign.
                    </>
                  )}
                </div>
              </div>

              {/* RIGHT SIDE */}
              <div className="text-end pe-4">
                <div
                  className="fw-bold font9"
                  style={{
                    letterSpacing: "-0.5px",
                    color:
                      analysis?.sms >=
                      analysis.summary.estimated_sms_cost
                        ? "#16a34a"
                        : "#dc2626",
                  }}
                >
                  [{analysis.sms}]
                </div>
              </div>
            </div>

            {/* Progress */}
            <div className="mt-3">
              <div
                style={{
                  height: "10px",
                  borderRadius: "999px",
                  background: "#ececec",
                  overflow: "hidden",
                }}
              >
                <div
                  style={{
                    width: `${Math.min(
                      (analysis.sms /
                        analysis.summary.estimated_sms_cost) *
                        100,
                      100
                    )}%`,
                    height: "100%",
                    borderRadius: "999px",
                    background:
                      analysis?.sms >=
                      analysis.summary.estimated_sms_cost
                        ? "linear-gradient(90deg,#22c55e,#4ade80)"
                        : "linear-gradient(90deg,#ff6b6b,#ff8787)",
                    transition: "0.4s ease",
                  }}
                />
              </div>

              <div className="d-flex justify-content-between mt-1">
                <small className="text-muted font8">
                  Needed:{" "}
                  {analysis.summary.estimated_sms_cost}
                </small>

                <small
                  className="fw-bold font8"
                  style={{
                    color:
                      analysis?.sms >=
                      analysis.summary.estimated_sms_cost
                        ? "#16a34a"
                        : "#dc2626",
                  }}
                >
                  {Math.max(
                    analysis.summary.estimated_sms_cost -
                      analysis.sms,
                    0
                  )}{" "}
                  remaining
                </small>
              </div>
            </div>

            {/* ACTIONS */}
            <div className="mt-3">
              {analysis?.sms >=
              analysis.summary.estimated_sms_cost ? (
                <Button
                  variant="success"
                  size="sm"
                  className="w-100 fw-bold"
                  style={{
                    borderRadius: "12px",
                    height: "42px",
                    fontSize: "0.8em",
                  }}
                  onClick={handleLaunchCampaign}
                  disabled={creatingRun}
                >
                  {creatingRun
                    ? "Launching..."
                    : state === "ACTIVE"
                    ? "Launch Another Campaign"
                    : "Launch Campaign"}
                </Button>
              ) : (
                <Button
                  variant="danger"
                  size="sm"
                  className="w-100 fw-bold"
                  style={{
                    borderRadius: "12px",
                    height: "42px",
                    fontSize: "0.8em",
                  }}
                  onClick={() => setShowRecharge(true)}
                >
                  Recharge SMS Credits
                </Button>
              )}
            </div>
          </div>
        )}
      </div>
      {/* RECHARGE MODAL */}
      {showRecharge && (
        <div
          className="modal fade show d-block"
          style={{
            background: "rgba(0,0,0,0.6)",
            zIndex: 9999,
          }}
        >
          <div className="modal-dialog modal-m mt70">
            <div
              className="modal-content"
              style={{
                borderRadius: "18px",
                overflow: "hidden",
                border: "none",
              }}
            >
              {/* HEADER */}
              <div className="modal-header bg-default text-dark border-0 pb-2 pt-3">
                <div className="col-11">
                  <div
                    className="fw-bold"
                    style={{
                      fontSize: "15px",
                    }}
                  >
                    Recharge SMS
                  </div>

                  <small className="text-muted">
                    Top up your SMS balance
                  </small>
                </div>

                <button
                  onClick={() => setShowRecharge(false)}
                  className="btn btn-sm"
                >
                  <X size={16} />
                </button>
              </div>

              {/* BODY */}
              <div className="modal-body pt-2">
                <div
                  className="mb-3 p-3"
                  style={{
                    borderRadius: "14px",
                    background: "#f8f8f8",
                  }}
                >
                  <div
                    className="text-muted mb-1"
                    style={{ fontSize: "12px" }}
                  >
                    Current Balance
                  </div>

                  <div
                    className="fw-bold"
                    style={{
                      fontSize: "24px",
                      letterSpacing: "-1px",
                    }}
                  >
                    {analysis?.sms || 0} SMS
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label font9">
                    Enter Amount (KES)
                  </label>

                  <input
                    type="number"
                    className="form-control"
                    value={rechargeAmount}
                    min="50"
                    onChange={(e) =>
                      setRechargeAmount(
                        Math.max(50, Number(e.target.value))
                      )
                    }
                    style={{
                      height: "48px",
                      borderRadius: "12px",
                    }}
                  />
                </div>

                {/* QUICK PICKS */}
                <div className="d-flex gap-2 mb-3">
                  {[50, 100, 200, 500, 1000].map((amount) => (
                    <button
                      key={amount}
                      className="btn btn-light flex-fill"
                      style={{
                        borderRadius: "10px",
                        fontSize: "0.8em",
                      }}
                      onClick={() =>
                        setRechargeAmount(amount)
                      }
                    >
                      {amount}
                    </button>
                  ))}
                </div>

                <PaystackButton
                  {...paystackProps}
                  className="btn btn-dark w-100"
                />
              </div>
            </div>
          </div>
        </div>
      )}

      <div
        className="modal fade"
        id="cooldownInfoModal"
        tabIndex="-1"
      >
        <div className="modal-dialog mt70">
          <div className="modal-content border-0">
            <div className="modal-body p-4">

              <div
                style={{
                  fontSize: "20px",
                  fontWeight: 700,
                  color: "#111827",
                }}
              >
                🛡 Smart Cooldown
              </div>

              <p
                className="mt-3 mb-3"
                style={{
                  fontSize: "14px",
                  lineHeight: "1.7",
                  color: "#4b5563",
                }}
              >
                Customers recently received a recovery campaign.
                To protect engagement and avoid message fatigue,
                the Reorder Agent temporarily pauses new campaigns.
              </p>

              <div
                className="p-3 mb-3"
                style={{
                  background: "#f9fafb",
                  borderRadius: "10px",
                }}
              >
                <div
                  style={{
                    fontSize: "12px",
                    fontWeight: 600,
                    color: "#111827",
                  }}
                >
                  Why this matters
                </div>

                <div
                  className="mt-2"
                  style={{
                    fontSize: "0.8em",
                    color: "#6b7280",
                    lineHeight: "1.6",
                  }}
                >
                  Sending recovery campaigns too frequently can
                  reduce open rates, click rates, and future
                  reorder conversions.
                </div>
              </div>

              <div
                className="p-3"
                style={{
                  background: "#fefaf5",
                  borderRadius: "10px",
                  border: "1px solid #f6d7b8",
                }}
              >
                <div
                  style={{
                    fontSize: "12px",
                    fontWeight: 600,
                    color: "#111827",
                  }}
                >
                  Current cooldown
                </div>

                <div
                  className="mt-1"
                  style={{
                    fontSize: "0.8em",
                    color: "#6b7280",
                  }}
                >
                  The agent will be ready again in{" "}
                  <strong>
                    {launchPolicy?.days_until_next_launch} day(s)
                  </strong>
                  .
                </div>

                <div
                  className="mt-2"
                  style={{
                    fontSize: "0.8em",
                    color: "#6b7280",
                  }}
                >
                  ✨Adding new qualifying orders may unlock a campaign sooner.
                </div>
              </div>

              <button
                className="btn btn-dark w-100 mt-4"
                data-bs-dismiss="modal"
              >
                Got it
              </button>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReorderAgentCard;